import React from "react";

const NewAdminForm = ({ onSubmit, onCancel }) => {
    const nameRef = React.createRef();
    return (
        <form
            method="POST"
            onSubmit={(event) => {
                event.preventDefault();
                onSubmit(nameRef.current.value);
                nameRef.current.value = "";
            }}
        >
            <div className="form-group">
                <label htmlFor="email-id">Email / Id</label>
                <input type="text" className="form-control input-height" id="email-id" required ref={nameRef} aria-describedby="email-id" placeholder="Enter identity" />
                <small id="email-id" className="form-text text-muted">
                    Enter staff's id/email address
                </small>
            </div>
            <div className="text-center">
                <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 margin-right-10 btn-circle btn-default">
                    <i className="material-icons text-danger">cancel</i> Cancel
                </button>

                <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10  btn-circle btn-success">
                    Submit <i className="material-icons">arrow_right_alt</i>
                </button>
            </div>
        </form>
    );
};

export default NewAdminForm;
